import React from "react";
import classnames from "classnames";

import "../../assets/extras.css";

class PromoPopup extends React.Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      visible: false,
      hidden: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ visible: true, hidden: false });
    }, 2500);
  }

  handleClose() {
    this.setState({
      visible: true,
      hidden: true
    });
  }

  handleShow() {
    this.setState({
      visible: true,
      hidden: false
    });
  }

  render() {
    const { visible, hidden } = this.state;

    const classes = classnames(
      "promo-popup",
      "animated",
      visible && "bounceIn",
      hidden && 'hidden'
    );

    return (
      <div>
        <div className={classes}>
          <a
            href="http://bit.ly/sdp-react"
            className="pp-cta extra-action"
          >
            <img src="https://dgc2qnsehk7ta.cloudfront.net/uploads/sd-blog-promo-2.jpg" alt="Shards Dashboard Pro React" />
          </a>
          <div className="pp-intro-bar">
            Need More Templates?
            <span className="close" onClick={this.handleClose}>
              <i className="material-icons">close</i>
            </span>
            <span className="up" onClick={this.handleShow}>
              <i className="material-icons">keyboard_arrow_up</i>
            </span>
          </div>
          <div className="pp-inner-content">
            <h2>Shards Dashboard Pro</h2>
            <p>A premium & modern React admin dashboard template pack.</p>
            <a
              className="pp-cta extra-action"
              href="http://bit.ly/sdp-react"
            >
              Download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PromoPopup;
